import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import useFetchWrapper, { HttpResponse } from '../../Helpers/useFetchWrapper';
import { usePopupContext } from '../../Helpers/PopupProvider';
import { MyContactRequest, ReceivedContactRequest, Conversation } from './ContactDropdown.model';
import {useAuthorizationDataContext} from "../../Helpers/AuthorizationDataProvider";

const useContactDropdown = () => {
  const [ myRequests, setMyRequests ] = useState<MyContactRequest[]>([]);
  const [ network, setNetwork ] = useState<Conversation[]>([]);
  const [ pendingRequests, setPendingRequests ] = useState<ReceivedContactRequest[]>([]);
  const [ rejectedRequests, setRejectedRequests ] = useState<ReceivedContactRequest[]>([]);
  const [ viewSection, setViewSection ] = useState(false);

  const { get } = useFetchWrapper();
  const history = useHistory();
  const { onPopupClose, onPopupOpen } = usePopupContext();
	const { role } = useAuthorizationDataContext();

	useEffect(() => {
    onPopupOpen();
    getPendingRequests();
    getChatConversation();
    getMyRequests();
    getRejectedRequests();
  }, [])

  const getChatConversation = async () => {
    const response: HttpResponse<Conversation[]> = await get(`/communication`);
    response.parsedBody && setNetwork(response.parsedBody);
  }

  const getMyRequests = async () => {
    const response: HttpResponse<{chats: MyContactRequest[]}> = await get(`/communication/from?page=1&size=100`);
    response.parsedBody && setMyRequests(response.parsedBody.chats);
  }

  const getPendingRequests = async () => {
    const response: HttpResponse<ReceivedContactRequest[]> = await get(`/communication/to/pending?page=1&size=100`);
    response.parsedBody && setPendingRequests(response.parsedBody);
  }

  const getRejectedRequests = async () => {
    const response: HttpResponse<ReceivedContactRequest[]> = await get(`/communication/to/rejected?page=1&size=100`);
    response.parsedBody && setRejectedRequests(response.parsedBody);
  }

  const navigateTo = (path: string, close: ()=>void) => {
    history.push(path);
    close();
  }

  const toggleSection = () => {
    setViewSection((currentValue: boolean) => !currentValue);
  };
	

  return {
    navigateTo,
    onPopupClose,
    state: {
      myRequests,
      network,
      pendingRequests,
      rejectedRequests,
      viewSection
    },
    toggleSection,
  }
}

export default useContactDropdown;